"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRemoveAllSelectionsInCategory = void 0;
const react_1 = require("react");
const restrictions_1 = require("../models/restrictions");
/**
 * Helper function to remove all selection in a category for a built sales order item
 *
 * NOTE: this current only works for ones that have a category selection
 */
const useRemoveAllSelectionsInCategory = (salesOrderItemBuilt, categoryName, removeProducts) => {
    const { productBlueprint: { restrictions }, selectedProducts } = salesOrderItemBuilt;
    return (0, react_1.useCallback)(() => {
        // check that this category requires a category selection
        const hasCategoryMinMaxRestrictionRule = restrictions.some((restriction) => restriction.name === restrictions_1.TRestrictionRuleName.categoryMinMax &&
            restriction.category === categoryName);
        if (!hasCategoryMinMaxRestrictionRule) {
            return;
        }
        // get all ingredients in the category
        const productsToRemove = selectedProducts
            .map((selectedProduct) => {
            if (selectedProduct.product.category.name !== categoryName) {
                return null;
            }
            return selectedProduct.product;
        })
            .filter(x => x !== null);
        // remove all ingredient selections from built sale order item
        removeProducts(productsToRemove, true);
    }, [categoryName]);
};
exports.useRemoveAllSelectionsInCategory = useRemoveAllSelectionsInCategory;
//# sourceMappingURL=useRemoveAllSelectionsInCategory.js.map